export const cabinTotalPrice = (price: number, tax: number): number => {
  return parseInt((price + tax).toFixed(2))
}

export interface CruiseOfferPriceVariation {
  primaryPrice: {
    total: number
    type: string
    currencyCode: string
  }
  secondaryPrice?: {
    total: number
    type: string
    currencyCode: string
  }
}

export const getCruiseOfferPriceVariation = (
  offer: App.CruiseOffer,
  price?: App.CruisePrice | App.LowestPriceWithCategory | App.CruisePriceDetails,
): CruiseOfferPriceVariation => {
  if (!price) {
    return {
      primaryPrice: {
        total: 0,
        type: 'person',
        currencyCode: 'AUD',
      },
    }
  }

  const { total, currencyCode } = price

  const pricePerNight = {
    total: Math.round(total / offer.duration),
    currencyCode,
    type: 'night',
  }

  const pricePerPerson = {
    total,
    currencyCode,
    type: 'person',
  }

  if (offer.showPricePerNight) {
    return {
      primaryPrice: pricePerNight,
      secondaryPrice: pricePerPerson,
    }
  }

  return {
    primaryPrice: pricePerPerson,
  }
}
